import { createUser, editUser } from '../../_services/user.service';
import { getCompany } from '../../_utils/storage_handler';
import { 
    buildCreateSellerBody,
    cleanInputs,
    validateCreateSeller,
    validateEditSeller
} from './create_seller.input';

export const createSellerEvent = async () => {
    let body = buildCreateSellerBody(getCompany());
    validateCreateSeller(body);
    let res = await createUser(body);
    if(res.ok){
        cleanInputs();
    } else {
        throw new Error(res.error);
    }
    
    return res;
}

export const editSellerEvent = async (id) => {
    let body = buildCreateSellerBody(getCompany());
    validateEditSeller(body);
    let res = await editUser(body, id);
    if(! res.ok){
        throw new Error(res.error);
    }
    
    return res;
}